module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-event-973dee1c.svg";